import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

export const SkeletonWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  /* 🔹 위: 가로 3개 */
  .row-3 {
    display: grid; /* ✅ 핵심 */
    gap: 12px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  /* 🔹 아래: 가로 2개 */
  .row-2 {
    display: grid; /* ✅ 핵심 */
    gap: 12px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const SkeletonCard = styled.div`
  height: 200px;
  background: linear-gradient(180deg, #fff, #f8fafc);
  border-radius: 14px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const Circle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 50%, #f1f5f9 100%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.4s infinite linear;
`;

export const Line = styled.div<{ width?: string }>`
  width: ${({ width }) => width || "80%"};
  height: 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 50%, #f1f5f9 100%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.4s infinite linear;
`;
